import React from 'react';
import { Colors } from '@common/tokens';
import { Divider } from 'antd';
import {
  Conversation,
  ConversationPostProps,
} from '@common/components/conversation';
import { NotesForm, NotesFormProps } from './notes-form';
import { clsx } from 'clsx';

type section = {
  title: string;
  children?: JSX.Element;
  notes?: ConversationPostProps[];
};

type Props = {
  sections: section[];
  className?: string;
} & NotesFormProps;

export function Notes({ sections = [], className, ...props }: Props) {
  return (
    <>
      <div className={clsx('wk-notes', className)}>
        <NotesForm {...props} />
        <div>
          {sections.map((section) => (
            <section key={section.title}>
              <Divider className="wk-notes__divider">{section.title}</Divider>
              {section.children ? (
                <div>{section.children}</div>
              ) : (
                <Conversation posts={section.notes || []} />
              )}
            </section>
          ))}
        </div>
      </div>
      <style jsx>{`
        .wk-notes {
          padding: 24px;
          border-radius: 4px;
          border: 1px solid ${Colors.steel};
          background-color: ${Colors.white};
          box-shadow: 0px 1px 3px rgba(18, 81, 91, 0.15);
          max-width: 800px;
        }
        .wk-notes :global(.wk-notes__divider) {
          color: ${Colors.midnightLighter};
          font-weight: 400;
        }
      `}</style>
    </>
  );
}
